import {
  showMessage,
  logMessage,
  debounceAsync,
  start,
  end,
  getResponseByMode,
  isError,
  serialize
} from './utils';
import {
  updateBasket
} from './basket';
import {
  dialog
} from '../base';
import {
  getDevAttr,
  getDevUrlupdateprice
} from './joomshopping-data';


const test = document.body.dataset.mode === 'development';

if (test) {
  console.log('В моках у атрибутов 48 + 176 - 182 (5) в корзине лежит 3 товара');
  getDevAttr();
}
export class ProductAction {
  constructor() {
    this._form = document.querySelector('#form-product');
    this._submit = this._form.querySelector('[data-type="submit"]');
    if (this._submit === null) {
      return;
    }
    this._container = this._form.querySelector('.action-product__btns');
    this._wrapper = this._form.querySelector('[data-type="wrapper"]');
    this._link = this._form.querySelector('[data-type="link"]');
    this._controls = this._form.querySelector('[data-type="btns"]');
    this._plus = this._form.querySelector('[data-type="plus"]');
    this._minus = this._form.querySelector('[data-type="minus"]');
    this._input = this._form.querySelector('[data-type="count"]');

    this._updateValueFromDataset();

    this._count = this._input.value;
    this._goToCart = true;
    this._timerId = 0;

    this._prevAjaxHandler = null;
    this._reloadAttribEvents = [];
    this._extdataurlupdateattr = {};
    this._productId = document.querySelector('#product_id').value;
    this._urlupdateprice = getResponseByMode(null, window.location.origin + '/shop/product/ajax_attrib_select_and_price/' + this._productId + '?ajax=1');
    this._priceContainer = document.querySelector('#block_price');
    this._purchaseContainer = document.querySelector('.action-product__purchase');
    this._notifyContainer = document.querySelector('.action-product__notify');

    this._submitHandler = this._submitHandler.bind(this);
    this._plusClickHandler = this._plusClickHandler.bind(this);
    this._minusClickHandler = this._minusClickHandler.bind(this);
    this._inputChangeHandler = this._inputChangeHandler.bind(this);
    this._submitData = debounceAsync(this._submitData.bind(this));
    this._reloadAttribSelectAndPrice = this._reloadAttribSelectAndPrice.bind(this);

    this._form.addEventListener('submit', this._submitHandler);
    this._plus.addEventListener('click', this._plusClickHandler);
    this._minus.addEventListener('click', this._minusClickHandler);
    this._input.addEventListener('change', this._inputChangeHandler);

    window.setAttrValue = this.setAttrValue.bind(this);
    this._renameSubmitBtn();
  }

  setAttrValue(id, value) {
    attr_value[id] = value;

    this._renameSubmitBtn();
    this._showLoader(true);
    this._reloadAttribSelectAndPrice(id);
  }

  _updateValueFromDataset() {
    // Если ничего не добавлено в корзину, value по умолчанию будет равен 1. Таким образом, даже без js пользвоатель сможет добавить товар в корзину.
    // поэтому реальный value сохраняем в data-value и обновляем данные при загрузке оттуда

    this._input.value = this._input.dataset.value;
    delete this._input.dataset.value;
  }


  _renameSubmitBtn() {
    if (this._allChecked()) {
      this._submit.querySelector('.purchase__text').textContent = 'Есть в наличии';
    } else {
      this._submit.querySelector('.purchase__text').textContent = 'Выберите параметры';
    }
  }

  _showLoader(bool) {
    if (bool) {
      this._timerId = setTimeout(() => {
        this._container.classList.add('action-product__btns--loading');
      }, 500);
    } else {
      clearTimeout(this._timerId);
      this._container.classList.remove('action-product__btns--loading');
    }
  }

  _submitHandler(evt) {
    evt.preventDefault();

    const isSelectAll = this._allChecked();

    if (isSelectAll) {
      this._showControls();
      this._input.value++;

      const promise = this._submitData();
      promise
        .then((data) => {
          if (this._goToCart) {
            this._showModal(data.key);
            this._goToCart = false;

            // eslint-disable-next-line no-undef
            ym(33051953, 'reachGoal', 'click');

          }
        })
        .catch(() => {

          this._showOneButton();
          this._input.value--;
        });

    } else {
      dialog.open('attribute');
    }
  }

  _plusClickHandler() {
    this._input.value++;

    const promise = this._submitData();
    promise.catch(() => this._input.value--);
  }

  _minusClickHandler() {

    if (this._input.value === '1') {

      this._showOneButton();
      this._input.value--;

      const promise = this._submitData();
      promise.catch(() => {
        this._showControls();
        this._input.value++;
      });

    } else if (this._input.value > 0) {
      this._input.value--;

      const promise = this._submitData();
      promise.catch(() => {
        this._input.value++;
      });

    }
  }

  _inputChangeHandler() {

    if (this._input.value < '1') {
      this._showOneButton();
    }

    const promise = this._submitData();
    promise.catch(() => {
      this._input.value = this._count;

      if (this._input.value > '0') {
        this._showControls();
      }
    });
  }

  _showOneButton() {
    this._wrapper.classList.add('hide');
    this._submit.classList.remove('hide');
    this._link.classList.add('hide');
    this._controls.classList.add('hide');
  }

  _showControls() {
    this._wrapper.classList.remove('hide');
    this._submit.classList.add('hide');
    this._link.classList.remove('hide');
    this._controls.classList.remove('hide');
  }

  _submitData() {

    start();

    const mock = {
      url: 'mocks/product.json',
      options: {
        method: 'GET',
      }
    };

    const formData = new FormData(this._form);
    const loadUrl = new URL(this._form.action);
    loadUrl.searchParams.set('ajax', 1);

    const real = {
      url: loadUrl.href,
      options: {
        method: 'POST',
        body: serialize(this._form)
      }
    };

    const {
      url,
      options
    } = getResponseByMode(mock, real);

    return fetch(url, options)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error(`Не получилось добавить товар в корзину`);
      })
      .then((data) => {
        isError(data);
        return data;
      })
      .then((data) => {
        updateBasket(data.count);
        // if (redirect) {
        //   location.pathname = '/shop/checkout/';
        //   return;
        // }
        this._count = this._input.value;
        return data;
      })
      .catch((error) => {
        logMessage(error);
        showMessage(error.message);

        throw new Error(error);
      })
      .finally(() => end());
  }

  _showModal(key) {
    const mediaQuery = window.matchMedia('(min-width: 992px)');
    if (mediaQuery.matches) {
      this._showDialog(key);
    }
  }

  _showDialog(key) {

    const purchaseLink = document.querySelector('.action-product__btn--buy');
    const mock = 'mocks/purchase.html';
    const real = '/index.php?option=com_jshopping&controller=product&task=modalAddCart';
    const url = getResponseByMode(mock, real);


    dialog.open('purchase', {
      link: purchaseLink,
      action: url + '&key=' + key,
    });

  }

  _reloadAttribSelectAndPrice(attributeId) {

    const data = this._createData(attributeId);
    const config = this._getUrl(data);

    fetch(config)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((json) => {
        var reload_atribut = 0;
        for (var i = 0; i < attr_list.length; i++) {
          var id = attr_list[i];
          if (reload_atribut) {
            document.querySelector('#block_attr_sel_' + id).innerHTML = json['id_' + id];
          }
          if (id == attributeId) {
            reload_atribut = 1;
          }
        }

        this._updatePrice(json.price);
        this._insertCount(json.itemCartCount);
        this._showLoader(false);
        this._switchCartBox(json.displaybuttons);
        this._reloadAttrValue();
      });
  }

  _createData(attributeId) {
    const qty = this._input.value;
    let data = {};

    data['change_attr'] = attributeId;
    data['qty'] = qty;

    for (let i = 0; i < attr_list.length; i++) {
      const id = attr_list[i];
      data['attr[' + id + ']'] = attr_value[id];
    }

    for (extdatakey in this._extdataurlupdateattr) {
      data[extdatakey] = this._extdataurlupdateattr[extdatakey];
    }

    return data;
  }

  _getUrl(data) {
    if (test) {
      this._urlupdateprice = getDevUrlupdateprice(data);
      return this._urlupdateprice;
    } else {
      const url = new URL(this._urlupdateprice);
      Object.keys(data).forEach(key => url.searchParams.append(key, data[key]));
      return url;
    }
  }

  _allChecked() {
    const groups = this._form.querySelectorAll('[id^="block_attr_sel_"]');
    return Array.from(groups).every(group => {
      const controls = group.querySelectorAll('[id^="jshop_attr_id"]');
      return Array.from(controls).some(control => {
        if (control.nodeName === 'SELECT') {
          return control.selectedIndex !== 0;
        } else {
          return control.checked === true;
        }
      });
    });
  }

  _updatePrice(price) {
    this._priceContainer.innerHTML = price;
  }

  _insertCount(string) {
    const num = Number(string);
    if (num > 0) {
      this._input.value = num;
      this._showControls();
    } else {
      this._input.value = 0;
      this._showOneButton();
    }
  }

  _switchCartBox(displayButtons) {
    if (displayButtons === '1') {
      this._showPurchase();
    } else {
      this._showNotify();
    }
  }

  _showPurchase() {
    this._purchaseContainer.classList.remove('hide');
    this._notifyContainer.classList.add('hide');
  }

  _showNotify() {
    this._purchaseContainer.classList.add('hide');
    this._notifyContainer.classList.remove('hide');
  }

  _reloadAttrValue() {
    for (var id in attr_value) {
      if (jQuery('input[name=jshop_attr_id\\[' + id + '\\]]').attr('type') == 'radio') {

        attr_value[id] = jQuery('input[name=jshop_attr_id\\[' + id + '\\]]:checked').val();
      } else {

        attr_value[id] = jQuery('#jshop_attr_id' + id).val();
      }
    }
  }
}
